import { render, staticRenderFns } from "./LeaveReasons.vue?vue&type=template&id=1a1a4c2a&"
import script from "./LeaveReasons.vue?vue&type=script&lang=js&"
export * from "./LeaveReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports